(function plpAddToCart() {

  // PLP "Add to cart" buttons are rendered by Boost, which keeps its own click
  // handler on them. When Boost's cart drawer is disabled that handler finishes
  // with a hard navigation to /cart, so any click that lands before Boost's
  // customization script attaches its own listener bounces the user to the cart.
  //
  // Listening on `window` in the capture phase always runs before any handler on
  // `document` or on the button itself, whatever order the scripts loaded in, so
  // the theme owns the click outright and Boost never gets to redirect.

  const SELECTOR = ".atc_btn, .buy-now-btn";

  // window.eHS.addToCart swallows cart errors: it neither rejects nor returns the
  // payload, so callers cannot tell a failed add from a successful one. Tap the
  // response here instead of re-posting - the original promise is passed straight
  // back and the body is read from a clone, so nothing downstream sees a change.
  let lastAddResponse = null;

  const originalFetch = window.fetch;

  window.fetch = function (input, init) {
    const promise = originalFetch.apply(this, arguments);

    try {
      const url = typeof input === "string" ? input : input && input.url;
      if (url && url.indexOf("/cart/add.js") !== -1) {
        lastAddResponse = promise
          .then((res) => res.clone().json())
          .catch(() => null);
      }
    } catch (e) {
      console.warn("[plp-add-to-cart] could not tap cart response:", e);
    }

    return promise;
  };

  const getVariantId = (btn) => btn.dataset.variantid || btn.dataset.variantId || "";

  const getLabel = (btn) =>
    btn.querySelector(".boost-sd__button-text, .boost-sd__cta-button-text") || btn;

  const showError = (btn, message) => {
    const card = btn.closest(".boost-sd__product-item, .card-product") || btn.parentElement;
    let errorEl = card.querySelector(".plp-atc-error");

    if (!errorEl) {
      errorEl = document.createElement("p");
      errorEl.className = "plp-atc-error";
      errorEl.setAttribute("role", "status");
      errorEl.setAttribute("aria-live", "polite");
      errorEl.style.cssText =
        "margin-top:8px;padding:8px 10px;border:1px solid #c8102e;border-radius:6px;background:#ffdbde;color:#c8102e;font-size:12px;font-weight:600;";
      btn.insertAdjacentElement("afterend", errorEl);
    }

    errorEl.textContent = message;
    errorEl.style.display = "block";

    clearTimeout(errorEl._hideTimeout);
    errorEl._hideTimeout = setTimeout(() => {
      errorEl.style.display = "none";
    }, 6000);
  };

  const clearError = (btn) => {
    const card = btn.closest(".boost-sd__product-item, .card-product") || btn.parentElement;
    const errorEl = card.querySelector(".plp-atc-error");
    if (errorEl) errorEl.style.display = "none";
  };

  const addToCart = (variantId) => {
    if (window.eHS && typeof window.eHS.addToCart === "function") {
      return window.eHS.addToCart(variantId, 1);
    }

    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });
  };

  window.addEventListener("click", (e) => {
    const btn = e.target.closest && e.target.closest(SELECTOR);
    if (!btn) return;

    // Claim the click before Boost can act on it, even for buttons we skip
    // below - otherwise Boost's handler still redirects to /cart.
    e.preventDefault();
    e.stopImmediatePropagation();

    if (btn.disabled || btn.dataset.adding === "true") return;
    if (btn.dataset.available === "false") return;

    const variantId = getVariantId(btn);
    if (!variantId) {
      console.warn("[plp-add-to-cart] no variant id on button", btn);
      return;
    }

    const label = getLabel(btn);
    const addLabel = btn.dataset.addLabel || label.textContent.trim() || "Add to cart";

    clearError(btn);
    lastAddResponse = null;
    btn.dataset.adding = "true";
    btn.disabled = true;
    label.textContent = "Adding...";

    Promise.resolve(addToCart(variantId))
      .then(() => lastAddResponse)
      .then((response) => {
        // Shopify answers a rejected add with { status, message, description };
        // a successful one has no status field. A null tap means the request
        // never completed at all.
        if (!response) {
          showError(btn, "Couldn't reach the cart. Please check your connection and try again.");
          label.textContent = addLabel;
          return;
        }

        if (response.status) {
          showError(btn, response.description || response.message || "This item could not be added to your cart.");
          label.textContent = addLabel;
          return;
        }

        label.textContent = "Added!";
      })
      .catch((err) => {
        console.error("[plp-add-to-cart] add failed:", err);
        showError(btn, "This item could not be added to your cart. Please try again.");
        label.textContent = addLabel;
      })
      .finally(() => {
        setTimeout(() => {
          btn.dataset.adding = "false";
          btn.disabled = false;
          label.textContent = addLabel;
        }, 1500);
      });
  }, true);

})();
